(() => {
  'use strict';

  if (customElements.get('qnk-free-shipping-progress')) return;

  class QnkFreeShippingProgress extends HTMLElement {
    connectedCallback() {
      this.messageElement = this.querySelector(
        '.qnk-free-shipping__message'
      );

      this.pipoElement = this.querySelector(
        '.qnk-free-shipping__pipo'
      );

      this.thresholdCents =
        Number(this.dataset.thresholdCents) || 7900;

      this.currentCents =
        Number(this.dataset.currentCents) || 0;

      this.wasComplete =
        this.currentCents >= this.thresholdCents;

      this.render(this.currentCents, false);
      this.cartItems = this.closest('cart-items');

if (this.cartItems) {
  const cartContent =
    this.cartItems.querySelector('#main-cart-items');

  if (cartContent) {
    this.cartObserver = new MutationObserver(() => {
      this.queueRefresh();
    });

    this.cartObserver.observe(cartContent, {
      childList: true,
      subtree: true
    });
  }
}

      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        this.unsubscribe = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            const cartData = event?.cartData;

            if (
              cartData &&
              typeof cartData.total_price === 'number'
            ) {
              this.render(cartData.total_price, true);
            }
          }
        );
      }
    }

    disconnectedCallback() {
  if (typeof this.unsubscribe === 'function') {
    this.unsubscribe();
  }

  if (this.abortController) {
    this.abortController.abort();
  }

  if (this.cartObserver) {
    this.cartObserver.disconnect();
  }

  clearTimeout(this.refreshTimer);

  this.unsubscribe = null;
  this.abortController = null;
  this.cartObserver = null;
  this.refreshTimer = null;
}
queueRefresh() {
  clearTimeout(this.refreshTimer);

  this.refreshTimer = setTimeout(() => {
    this.refresh();
  }, 100);
}
    async refresh() {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();

      try {
        const root =
          window.Shopify?.routes?.root || '/';

        const response = await fetch(
          `${root}cart.js`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json'
            },
            cache: 'no-store',
            signal: this.abortController.signal
          }
        );

        if (!response.ok) return;

        const cart = await response.json();

        if (typeof cart.total_price === 'number') {
          this.render(cart.total_price, true);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn(
            'QNK free shipping progress could not update.'
          );
        }
      }
    }

    formatEuros(cents) {
      const locale =
        this.dataset.locale ||
        document.documentElement.lang ||
        'es';

      const amount =
        Math.max(0, Number(cents) || 0) / 100;

      const formatted =
        new Intl.NumberFormat(locale, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(amount);

      return `${formatted}\u00A0€`;
    }

    render(nextCents, allowCelebration) {
      const safeCents =
        Math.max(0, Number(nextCents) || 0);

      const complete =
        safeCents >= this.thresholdCents;

      const percentage =
        Math.min(
          100,
          (safeCents / this.thresholdCents) * 100
        );

      this.currentCents = safeCents;

      this.style.setProperty(
        '--qnk-progress',
        `${percentage}%`
      );

      this.dataset.complete =
        complete ? 'true' : 'false';

      if (this.messageElement) {
        if (complete) {
          this.messageElement.textContent =
            this.dataset.afterText;
        } else {
          const remaining =
            this.thresholdCents - safeCents;

          this.messageElement.textContent =
            this.dataset.beforeText.replace(
              '{amount}',
              this.formatEuros(remaining)
            );
        }
      }

      if (
        complete &&
        !this.wasComplete &&
        allowCelebration &&
        this.pipoElement
      ) {
        this.pipoElement.classList.remove(
          'qnk-free-shipping__pipo--pop'
        );

        void this.pipoElement.offsetWidth;

        this.pipoElement.classList.add(
          'qnk-free-shipping__pipo--pop'
        );

        this.pipoElement.addEventListener(
          'animationend',
          () => {
            this.pipoElement?.classList.remove(
              'qnk-free-shipping__pipo--pop'
            );
          },
          { once: true }
        );
      }

      this.wasComplete = complete;
    }
  }

  customElements.define(
    'qnk-free-shipping-progress',
    QnkFreeShippingProgress
  );
})();